/**
 * HPQ GA4 Event Bridge
 *
 * Bridges Stiletto custom DOM events to GA4 gtag() calls.
 * Requires: useCustomEvents = true in theme-globals.liquid
 * Requires: GA4 Measurement ID configured in Shopify Admin
 *
 * Events instrumented:
 *   view_item        — PDP page load
 *   add_to_cart      — cart:item-added (Stiletto event)
 *   view_cart        — quick-cart:open (Stiletto event) + /cart page
 *   begin_checkout   — checkout form submit
 */

(function () {
  'use strict';

  // Guard: gtag must exist (injected by Shopify via content_for_header)
  if (typeof gtag !== 'function') return;

  var dataEl = document.getElementById('hpq-ga4-data');
  var pageData = dataEl ? JSON.parse(dataEl.textContent) : {};

  // -- view_item: fires on PDP pages --
  if (pageData.product) {
    var p = pageData.product;
    gtag('event', 'view_item', {
      currency: pageData.currency || 'USD',
      value: p.price,
      items: [{
        item_id: p.id,
        item_name: p.title,
        item_category: p.type,
        item_variant: p.variant,
        price: p.price,
        quantity: 1
      }]
    });
  }

  // -- view_cart: fires on /cart page --
  if (pageData.page_type === 'cart' && pageData.cart) {
    gtag('event', 'view_cart', {
      currency: pageData.currency || 'USD',
      value: pageData.cart.total,
      items: pageData.cart.items
    });
  }

  // -- add_to_cart: bridges cart:item-added --
  document.addEventListener('cart:item-added', function (evt) {
    var product = evt.detail.product;
    if (!product) return;

    gtag('event', 'add_to_cart', {
      currency: pageData.currency || 'USD',
      value: product.final_price / 100,
      items: [{
        item_id: product.product_id,
        item_name: product.product_title,
        item_variant: product.variant_title,
        price: product.final_price / 100,
        quantity: product.quantity
      }]
    });
  });

  // -- view_cart: bridges quick-cart:open --
  document.addEventListener('quick-cart:open', function (evt) {
    var cart = evt.detail.cart;
    if (!cart) return;

    var items = cart.items.map(function (item) {
      return {
        item_id: item.product_id,
        item_name: item.product_title,
        item_variant: item.variant_title,
        price: item.final_price / 100,
        quantity: item.quantity
      };
    });

    gtag('event', 'view_cart', {
      currency: cart.currency || 'USD',
      value: cart.total_price / 100,
      items: items
    });
  });

  // -- begin_checkout: intercepts checkout button click --
  // Stiletto posts to /cart with name="checkout" which triggers Shopify checkout redirect.
  // Cache latest cart data from events, use it when checkout is clicked.
  var lastCart = null;

  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) lastCart = evt.detail.cart;
  });

  document.addEventListener('quick-cart:open', function (evt) {
    if (evt.detail && evt.detail.cart) lastCart = evt.detail.cart;
  });

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[name="checkout"]');
    if (!btn) return;
    if (!lastCart) return;

    try {
      var items = lastCart.items.map(function (item) {
        return {
          item_id: item.product_id,
          item_name: item.product_title,
          item_variant: item.variant_title,
          price: item.final_price / 100,
          quantity: item.quantity
        };
      });

      gtag('event', 'begin_checkout', {
        currency: lastCart.currency || 'USD',
        value: lastCart.total_price / 100,
        items: items
      });
    } catch (e) {
      // Fail silently — don't block checkout
    }
  });
})();
